import type { DataItem as SpecialOptionsConfirmStepNewAirRoadCustomTableDataItem } from '@/components/customTables/SpecialOptionsConfirmStepNewAirRoadCustomTable.vue';

import { format, toZonedTime } from 'date-fns-tz';

import { getStrCell } from '@/utils/file';
import * as airRoadHelpers from '@/helpers/airRoad';
import { ARServiceItem } from '@/models/airRoad';

export function getTableItem(
  arServiceItem: ARServiceItem,
  num: number,
  type: 'Delivery' | 'Pickup',
  stopTimeZone: string,
  zoneString: string,
): SpecialOptionsConfirmStepNewAirRoadCustomTableDataItem {
  let datetime;
  if (arServiceItem._date != null && arServiceItem._time != null) {
    datetime = airRoadHelpers.getARServiceItemDatetime(
      arServiceItem._date,
      arServiceItem._time,
      zoneString,
    );
  }

  return {
    _id: arServiceItem.code + type,
    num,
    type,
    code: arServiceItem.code,
    name: getStrCell(arServiceItem.contact_name),
    phone: getStrCell(arServiceItem.contact_phone),
    description: getStrCell(arServiceItem.description),
    time: getStrCell(
      datetime
        ? format(
            toZonedTime(new Date(datetime), stopTimeZone),
            'yyyy-MM-dd HH:mm aa',
          )
        : undefined,
    ),
    firstDate: getStrCell(
      arServiceItem._dateFrom
        ? format(
            toZonedTime(new Date(arServiceItem._dateFrom), stopTimeZone),
            'yyyy-MM-dd HH:mm aa',
          )
        : undefined,
    ),
    secondDate: getStrCell(
      arServiceItem._dateTo
        ? format(
            toZonedTime(new Date(arServiceItem._dateTo), stopTimeZone),
            'yyyy-MM-dd HH:mm aa',
          )
        : undefined,
    ),
  };
}
